module.exports = __webpack_public_path__ + "media/images/front/varieties/NADORCOTT-4767fe8ce43c69bd4950968d6dbed3e1.jpg";